<template>
  <div data-app>
    <div
      role="alert"
      v-bind:class="{ show: errors.length }"
      class="alert fade alert-danger"
    >
      <div class="alert-text" v-for="(error, i) in errors" :key="i">
        {{ error }}
      </div>
    </div>
    <v-card>
      <v-card-title>Script {{ url }} History</v-card-title>
      <v-card-text>
        <v-btn color="primary" dark class="mb-2" @click="exportToCsv">
          <v-icon left>mdi-download</v-icon>
          Download CSV
        </v-btn>
      </v-card-text>
      <v-data-table
        v-model="selected"
        :loading="loading"
        :headers="headers"
        :items="history"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50, 100],
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-chevron-left',
          nextIcon: 'mdi-chevron-right',
        }"
        :items-per-page="itemsPerPage"
        :server-items-length="totalHistory"
        item-key="id"
        class="elevation-1"
      >
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import api from "@/common/api.service";
import Errors from "@/common/errors";
import { jsonToCsv, downloadCsv } from "@/common/json-to-csv";

export default {
  mounted() {
    this.fetchHistory();
  },

  data: () => ({
    path: "",
    selected: [],
    headers: [
      { text: "Hash", value: "hash" },
      { text: "Created At", value: "created_at" },
    ],
    history: [],
    errors: [],
    loading: true,
    search: "",
    url: "",
    itemsPerPage: 10,
    searchCounter: 0,
  }),

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    fetchHistory() {
      this.searchCounter++;
      const currentRequest = this.searchCounter;
      this.loading = true;

      api
        .query(`v2/waf/page_security/scripts/${this.$route.params.script_id}`)
        .then((response) => {
          if (this.searchCounter == currentRequest) {
            this.url = response.data.url;
            this.history = response.data.history.map((h) => ({
              hash: h.hash,
              created_at: new Date(h.created_at).toLocaleString(),
            }));
          }
        })
        .catch((error) =>
          this.errors.push(...Errors.extractErrorMessage(error))
        )
        .finally(() => {
          this.loading = false;
        });
    },

    async exportToCsv() {
      try {
        const csv = jsonToCsv(this.history);
        downloadCsv(csv, this.url.split("/").pop() + "_history.csv");
      } catch (error) {
        console.error("Error exporting to CSV:", error);
        this.errors.push("Failed to export data to CSV");
      }
    },
  },
};
</script>
